import React from "react";
import { SVGIconProps } from "./SVGIconProps";
function CircleExclamation(props: SVGIconProps) {
    const { width = 16, height = 16, fillColor = "#DA3E33", onClick } = props;
    return (
        <svg width={width} height={height}  onClick={onClick} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 14.5C5.84375 14.5 3.875 13.375 2.79688 11.5C1.71875 9.64844 1.71875 7.375 2.79688 5.5C3.875 3.64844 5.84375 2.5 8 2.5C10.1328 2.5 12.1016 3.64844 13.1797 5.5C14.2578 7.375 14.2578 9.64844 13.1797 11.5C12.1016 13.375 10.1328 14.5 8 14.5ZM8 5.5C7.67188 5.5 7.4375 5.75781 7.4375 6.0625V8.6875C7.4375 9.01562 7.67188 9.25 8 9.25C8.30469 9.25 8.5625 9.01562 8.5625 8.6875V6.0625C8.5625 5.75781 8.30469 5.5 8 5.5ZM7.25 10.75C7.25 11.1719 7.57812 11.5 8 11.5C8.39844 11.5 8.75 11.1719 8.75 10.75C8.75 10.3516 8.39844 10 8 10C7.57812 10 7.25 10.3516 7.25 10.75Z" fill={fillColor} />
        </svg>
    );
}
export default CircleExclamation;
